import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/UserAbout/config';
import cn from 'classnames';
import s from './UserAbout.scss';
const UserAboutViewer = /*#__PURE__*/ React.forwardRef(({ contentJson, className, externalRenderers, cookieType, defaultSize }, ref)=>{
    return /*#__PURE__*/ React.createElement(Viewer, {
        presetId: "userabout",
        contentJson: contentJson,
        className: cn(s['root'], className),
        extensionConfig: extConfig,
        externalRenderers: externalRenderers,
        cookieType: cookieType,
        defaultSize: defaultSize,
        ref: ref
    });
});
UserAboutViewer.displayName = 'UserAboutViewer';
export default UserAboutViewer;

//# sourceMappingURL=UserAbout.js.map